// 后台同时接收 pc-api 和 mobile-api 产生的业务事件。
let websocketUrls;
if (process.env.NODE_ENV === 'development') {
  websocketUrls = [
    'http://localhost:9204/ws',
    'http://localhost:9306/ws'
  ];
} else {
  websocketUrls = [
    '/prod-api/pc-api/ws',
    '/prod-api/mobile-api/ws'
  ];
}

const websocketUrl = websocketUrls[0];

export { websocketUrl, websocketUrls };
